import { NotificationsService } from './shared/notifications.service';
import { MomentModule } from 'angular2-moment';
import { FormsModule } from '@angular/forms';
import { NotificationRoutingModule } from './notifications.routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications.component';
import { NotificationEditComponent } from './notification-edit/notification-edit.component';
import { NotificationPreviewComponent } from './notification-preview/notification-preview.component';

@NgModule({
  imports: [
    CommonModule, NotificationRoutingModule, FormsModule, MomentModule
  ],
  declarations: [
    NotificationsComponent,
    NotificationEditComponent,
    NotificationPreviewComponent
  ],
  providers: [
    NotificationsService
  ]
})
export class NotificationsModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/notifications/notifications.module.ts